module.exports = __webpack_public_path__ + "static/media/Mod2.aba0675e.png";